import React, { memo, useEffect, useRef, useState } from 'react';
import { Icons } from 'react-toastify';
import copyIcon from '../assets/img/copy.svg'

const ContextMenu = ({ position, onClose, onSelect, isSender, isMedia }) => {
  const menuRef = useRef(null);
  const imageExtensions = ["jpg","jpeg","png","gif","bmp","webp","svg","tiff","ico","avif","heic"];
  const audioExtensions = [
  "3gp", "aa", "aac", "aax", "ac3", "aiff", "alac", "amr", "ape", "au",
  "dts", "flac", "gsm", "m4a", "m4b", "m4p", "mka", "mlp", "mod", "mp3",
  "mpa", "mpc", "msv", "oga", "ogg", "opus", "ra", "ram", "raw", "snd",
  "spx", "tta", "voc", "vqf", "wav", "wma", "wv"
];
  const [adjustedPosition, setAdjustedPosition] = useState(position);

  useEffect(() => {
    const adjustPosition = () => {
      if (!menuRef.current) return;

      const menuWidth = 90;
      const menuHeight = 208;

      let { x, y } = position;

      if (x + menuWidth > window.innerWidth) {
        x = window.innerWidth - menuWidth - 0;
      }

      if (y + menuHeight > window.innerHeight) {
        y = window.innerHeight - menuHeight - 0;
      }

      if (isSender && x - menuWidth > 0) {
        x = x - menuWidth;
      }

      setAdjustedPosition({ x, y });
    };

    adjustPosition();

    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [position, isSender, onClose]);

  const menuItems = [
    { label: 'Reply', action: 'reply', icon: 'fa fa-reply' },
    { label: 'Copy', action: 'copy', icon: 'fa fa-clone' },
    { label: 'Download', action: 'download', icon: 'fa fa-download' },
    { label: 'Forward', action: 'forward', icon: 'fa fa-share' },
    { label: 'Delete', action: 'delete', icon: 'fa fa-trash-o' },
  ];

  return (
    <div
      ref={menuRef}
      className="context-menu-container"
      style={{ left: `${adjustedPosition.x}px`, top: `${adjustedPosition.y}px` }}
    >
      <div tabIndex="-1" className="context-menu" role="application">
        <ul>
          {menuItems.map((item) => {
            if ((item.action === 'delete' && !isSender) || 
             (item.action === 'download' && !(isMedia && imageExtensions.includes(isMedia.split(".").pop())) && !(isMedia && audioExtensions.includes(isMedia.split(".").pop()))) ) {
              return null;
            }

            return (
              <li
                key={item.action}
                tabIndex="0"
                data-animate-dropdown-item="true"
                role="button"
                onClick={() => onSelect(item.action)}
              >
                <i className={`${item.icon} mr-2`} aria-hidden="true" />
                {item.label}
              </li>
            );
          })}
        </ul>

      </div>
    </div>
  );
};

export default memo(ContextMenu);